import { useGenericRequestHandler } from '../../../handlers'

export const useAccountProfileMutation = (options = { method: 'POST' }) => {
  return useGenericRequestHandler({
    route: 'v1/i/profile',
    method: options.method
  })
}
